import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-bootstrap";
import LocationsList from "./locations_list";
import LocationsForm from "./locations_form";
import LocationsSrv from "../../services/locations_srv";



class Locations extends React.Component {

    locationsSrv;

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            locations: []
        };

        this.handleLocationAdded = this.handleLocationAdded.bind(this);
        this.getLocations = this.getLocations.bind(this);
        this.locationsSrv =  new LocationsSrv(this.props.auth);
    }

    handleLocationAdded(newLocstion) {
        this.getLocations();
    }

    componentDidMount() {
        this.getLocations();
    }

    getLocations() {

        this.locationsSrv.getAll()
            .then((res) => {
                    return res.json()
                }
            ) 
            .then((result) => {
                this.setState({
                    isLoaded: true,
                    locations: result
                });
            },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    console.log("error");
                    this.setState({
                        isLoaded: true,
                        error: error
                    });
                }
            ).catch(function(reason) {
                console.log("catch");
                this.setState({
                    isLoaded: true,
                    error: reason
                });
             });
    }

    render() {
        const { error, isLoaded, locations } = this.state;
        return (
            <Container>
                <Row>
                    <Col>
                        <LocationsForm 
                            newLocationAdded={this.handleLocationAdded} 
                            auth={this.props.auth}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <LocationsList 
                            locations={locations}
                            isLoaded={isLoaded}
                            error={error}
                        />
                    </Col>
                </Row>
            </Container>
        );
    }

}

Locations.propTypes = {
    auth: PropTypes.object
  };

export default Locations;